import { mergeMap, map, filter, take, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { isAuthenticatedSelector } from '@cbridge-packages/auth';
import { queryParamSelector } from '@cbridge-packages/routing';
import { PageContextAction } from '@cbridge-packages/page-context';
import { StreamParam } from '../_helpers/streamSearchParam';
import { StreamsFilterAction } from '../streamsFilter.action';

type IState =
  & IGetSelectorStateType<typeof queryParamSelector>
  & IGetSelectorStateType<typeof isAuthenticatedSelector>;

export const initStreamsFilterEpic: IEpic<IState> = (action$, state$) => {
  return state$.pipe(
    map((state) => ({
      streamId: queryParamSelector(state, StreamParam.name),
      isAuthenticated: isAuthenticatedSelector(state),
    })),
    filter(({ streamId, isAuthenticated }) => streamId && isAuthenticated),
    distinctUntilChanged(),
    take(1),
    mergeMap(({ streamId }) => {
      const parsedStreamId = Number(streamId);
      if (Number.isNaN(parsedStreamId)) {
        return [];
      }

      return [
        StreamsFilterAction.select({ streamId: parsedStreamId }),
      ];
    }),
    takeUntil(
      action$.pipe(
        isTypeOf(PageContextAction.init.done, PageContextAction.init.failed),
      ),
    ),
  );
};
